<template>
  <div>
    <Form ref="searchForm" inline :label-width="70" class="search-form">
      <Form-item label="全部试卷">
        <Select v-model="searchCondition.type" style="width:200px" clearable>
          <Option v-for="it in paperType" :key="it.key" :value="it.key">{{it.value}}</Option>
        </Select>
      </Form-item>
      <FormItem label="全部分类">
        <Cascader
          v-model="curPaperClassify"
          :data="paperClassify"
          trigger="hover"
          style="width:200px;"
          change-on-select
        ></Cascader>
      </FormItem>
      <Form-item label="试卷名称">
        <Input
          v-model="searchCondition.name"
          placeholder="请输入试卷名称关键字"
          style="width:200px"
          clearable
          @keydown.native.prevent.enter="search(1)"
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/exam/index"
        method="post"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        :selectType="selectType"
        keyField="id"
        :selectedItems="selectedItems"
        keepSelected
      ></Grid>
    </div>
  </div>
</template>
<script>
import { QuestionPaperType } from "@/utils/enums";
export default {
  name: "CourseSelect",
  data() {
    return {
      columns: [
        {
          title: "试卷名称",
          key: "name"
        },
        {
          title: "试题数目",
          key: "question_num"
        },
        {
          title: "试卷总分",
          key: "score"
        },
        {
          title: "更新时间",
          key: "updated_at"
        }
      ],
      paperType: QuestionPaperType.getOptions(),
      selectList: [],
      curPaperClassify: [],
      searchCondition: {
        name: "",
        type: "",
        classify_id: "",
        status: 1,
        init: function() {
          this.name = "";
          this.type = "";
          this.classify_id = "";
        }
      },
      paperClassify: []
    };
  },
  props: {
    selectedItems: {
      type: Array
    },
    selectType: {
      type: String,
      default: "single"
    }
  },
  methods: {
    rowsFormatter() {
      // rows.forEach(i => {});
    },
    search(flag) {
      if (flag == 0) {
        this.curPaperClassify = [];
        this.searchCondition.init();
      }
      if (this.curPaperClassify.length)
        this.searchCondition.classify_id = this.curPaperClassify[
          this.curPaperClassify.length - 1
        ];
      this.$refs.grid.searchRefresh();
    },
    onSelectionChange(val) {
      this.selectList = [...val];
    },
    getSelectList() {
      return this.selectList;
    },
    recoverSelectedItems(selectedItems) {
      this.$refs.grid.recoverSelectedItems(selectedItems);
    },
    getClassify() {
      this.$http.get(`/api/course/classify`).then(res => {
        this.paperClassify = res;
      });
    }
  },
  created() {
    this.getClassify();
  }
};
</script>
<style lang="scss" scoped>
</style>
